/** CNPJ numérico e alfanumérico (IN RFB 2.229/2024). */

const CNPJ_DV_WEIGHTS_1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const CNPJ_DV_WEIGHTS_2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

export function normalizeCNPJ(cnpj) {
  if (!cnpj) return '';
  return String(cnpj).toUpperCase().replace(/[^A-Z0-9]/g, '');
}

function cnpjCharValue(char) {
  const code = char.charCodeAt(0);
  if (code < 48 || code > 90) return NaN;
  return code - 48;
}

function calcCnpjCheckDigit(base, weights) {
  let sum = 0;
  for (let i = 0; i < base.length; i++) {
    const val = cnpjCharValue(base[i]);
    if (Number.isNaN(val)) return null;
    sum += val * weights[i];
  }
  const remainder = sum % 11;
  return remainder < 2 ? 0 : 11 - remainder;
}

export function validateCNPJ(cnpj) {
  if (!cnpj) return false;

  const cleaned = normalizeCNPJ(cnpj);
  if (!/^[A-Z0-9]{12}\d{2}$/.test(cleaned)) return false;
  if (/^([A-Z0-9])\1{13}$/.test(cleaned)) return false;

  const base12 = cleaned.slice(0, 12);
  const dv1 = calcCnpjCheckDigit(base12, CNPJ_DV_WEIGHTS_1);
  const dv2 = calcCnpjCheckDigit(`${base12}${dv1}`, CNPJ_DV_WEIGHTS_2);
  if (dv1 == null || dv2 == null) return false;

  return cleaned.slice(12) === `${dv1}${dv2}`;
}

export function formatCNPJ(cnpj) {
  const cleaned = normalizeCNPJ(cnpj);
  if (cleaned.length !== 14) return String(cnpj ?? '');
  return cleaned.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, '$1.$2.$3/$4-$5');
}

export function maskCNPJInput(value) {
  const chars = normalizeCNPJ(value).slice(0, 14);
  let out = '';
  for (let i = 0; i < chars.length; i++) {
    if (i === 2 || i === 5) out += '.';
    if (i === 8) out += '/';
    if (i === 12) out += '-';
    out += chars[i];
  }
  return out;
}
